export default "__VITE_ASSET__BafMsmbH__"